export enum ConceptStatus {
    Concept = 0,
    Submitted = 1,
}